import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { BoardService } from '../../board.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton, MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-board-add-file-dialog',
  templateUrl: './board-add-file-dialog.component.html',
  styleUrls: [],
  imports: [
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatError,
    MatMiniFabButton,
    MatIcon,
    MatDivider,
    MatDialogActions,
    MatButton,
    DatePipe,
    TranslateModule,
  ],
})
export class BoardAddFileDialogComponent {
  dialogRef = inject<MatDialogRef<BoardAddFileDialogComponent>>(MatDialogRef);
  private boardService = inject(BoardService);
  private translate = inject(TranslateService);
  data = inject(MAT_DIALOG_DATA);

  errorMessage: string;
  title = new UntypedFormControl(null, [Validators.required, Validators.minLength(7)]);
  type = new UntypedFormControl('board_agenda', [Validators.required]);
  isValid = false;
  uploadedFile: any = null;
  fileName = '';

  constructor() {
    const data = this.data;

    this.type.setValue(data.type);
    this.errorMessage = '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  validateInputs(): void {
    this.isValid = this.type.valid && this.fileName != null && this.fileName.length > 5;
  }

  getTitleErrorMessage(): string {
    if (this.title.hasError('required')) {
      return this.translate.instant('board.error_title_req');
    }

    return this.title.hasError('minlength')
      ? this.translate.instant('board.appointments.error_title_min_length')
      : '';
  }

  uploadFile(): void {
    this.validateInputs();
    if (this.isValid) {
      if (this.type.value === 'board_agenda') {
        this.boardService
          .uploadAgenda(this.data.meeting, this.fileName, this.uploadedFile)
          .subscribe(result => {
            if (result) {
              this.data.appointment = result;
              this.dialogRef.close(result);
            } else {
              this.errorMessage = this.translate.instant('board.appointments.error_upload');
            }
          });
      }
      if (this.type.value === 'board_minutes') {
        this.boardService
          .uploadMinutes(this.data.meeting, this.fileName, this.uploadedFile)
          .subscribe(result => {
            if (result) {
              this.data.appointment = result;
              this.dialogRef.close(result);
            } else {
              this.errorMessage = this.translate.instant('board.appointments.error_upload');
            }
          });
      }
      if (this.type.value === 'board_minutes_attachment') {
        this.boardService
          .uploadMinutesAttachment(
            this.data.meeting,
            this.fileName,
            this.title.value,
            this.uploadedFile
          )
          .subscribe(result => {
            if (result) {
              this.data.appointment = result;
              this.dialogRef.close(result);
            } else {
              this.errorMessage = this.translate.instant('board.appointments.error_upload');
            }
          });
      }
    }
  }

  onFileSelected(event: any): void {
    // console.log(event.target.files);
    if (event.target && event.target.files && event.target.files.length > 0) {
      this.uploadedFile = event.target.files[0];
      this.fileName = event.target.files[0].name;
    }
    this.validateInputs();
  }
}
